import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Candidatelist from "./Candidatelist";
import AddProfile from "./AddProfile";
import CandidateProfile from "./CandidateProfile";
import UserHomePage from "./UserHomePage";
import ATSMatch from "./ATSMatch";
import SharedByMe from "./common/SharedByMe";
import Login from "./Login";
import { END_POINTS } from "./Constants";

export function Router({ handleCustomLogin }) {

  const { CANDIDATE, CANDIDATE_LIST, ADD_PROFILE } = END_POINTS;
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  // Protected route
  const ProtectedRoute = ({ children, allowedRoles }) => {
  if (!isLoggedIn) {
      return <Navigate to="/login" replace />;
    }
  if (allowedRoles && !allowedRoles.includes(user?.role)) {
      return <Navigate to="/unauthorized" replace />;
    }
    return children;
  };
  // Default route based on role
  const getDefaultRoute = () => {
    if (!user) return "/login";
    switch (user.role) {
      case "admin":
        return CANDIDATE_LIST;
      case "recruiter":
        return "/profile";
      default:
        return CANDIDATE_LIST;
    }
  };

  return (
    <Routes>
      <Route
        path="/login"
        element={
          isLoggedIn
            ? <Navigate to={getDefaultRoute()} replace />
            : <Login handleCustomLogin={handleCustomLogin} />
        }
      />
      {/* DEFAULT */}
      <Route
        path="/"
        element={<Navigate to={getDefaultRoute()} replace />}
      />
      {/* ADMIN ROUTES */}
      <Route
        path={CANDIDATE_LIST}
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Candidatelist />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${CANDIDATE}/:id`}
        element={
          <ProtectedRoute>
            <CandidateProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path={ADD_PROFILE}
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AddProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/atsMatch"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ATSMatch />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <UserHomePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/shared"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <SharedByMe />
          </ProtectedRoute>
        }
      />
      {/* FALLBACK */}
      <Route path="/unauthorized" element={<h1>Unauthorized</h1>} />
      <Route path="*" element={<h1>404 Not Found</h1>} />
    </Routes>
  );
}